export default {
  inserted(el, binding) {
    if (binding.value === undefined || binding.value) el.focus();
  },
};
